<template>
  <div class="homeweb">
    <div class="head">
      <div class="swiper">
        <SwiperList :swiperList="swiperList"></SwiperList>
      </div>
    </div>
    <div v-if="sysparam">
      <div class="main">
        <template-a></template-a>
        <!--<div v-if="hometemplate === '1'">-->
          <!--<template-default></template-default>-->
        <!--</div>-->
        <!--<div v-if="hometemplate === '2'">-->
          <!--<template-b></template-b>-->
        <!--</div>-->
      </div>
    </div>
  </div>
</template>

<script>
  import {mapGetters, mapState} from 'vuex'
  import SwiperList from './SwiperList.vue'
  import utils from '../../assets/js/utils.js'
  // import TemplateDefault from '../HomeTemplate/templateDefault'
  import TemplateA from '../HomeTemplate/templateA'

  export default {
    data () {
      return {
        list: [],
        homeWconList: [],
        swiperList: []
      }
    },
    created () {
      this.findSwiperList()
      this.$store.dispatch('getSysparam')
    },
    methods: {
      // 头部广告图
      findSwiperList () {
        this.$store.dispatch('findSwiperList', {operadmtid: 0}).then(data => {
          if (data) {
            this.swiperList = data.appends
          }
        })
      }
    },
    filters: {
      shortDate: function (val) {
        return utils.formatterDate(val, 'yyyy-MM-dd').substring(0, 7)
      },
      shortDate2: function (val) {
        return utils.formatterDate(val, 'yyyy-MM-dd').substring(8, 10)
      },
      filter: function (val) {
        return val.length > 35 ? val.substring(0, 35) + '...' : val.substring(0, 35)
      },
      filter2: function (val) {
        return val.length > 18 ? val.substring(0, 18) + '...' : val.substring(0, 18)
      }
    },
    components: {SwiperList, TemplateA},
    computed: {
      ...mapState({
        sysparam: state => state.sysparam,
        picAddr: state => state.picAddr
      }),
      ...mapGetters({}),
      hometemplate () {
        if (this.sysparam && this.sysparam.hometemplate) {
          return this.sysparam.hometemplate.sysparambeg
        } else {
          return '1'
        }
      }
    }
  }
</script>

<style lang="stylus">
  .homeweb
    width 100%
    .head
      background-color #f0f0f0
      position: relative;
    .main
      margin:0 auto;
</style>



// WEBPACK FOOTER //
// WebHome.vue?3fbdd798